import React from "react";
import ReportPdfTemplate from "./ReportPdfTemplate";
import BlastingReportContent from "./BlastingReportContent";
import PaintingCoatReportContent from "./PaintingCoatReportContent";
import AdditionsReportContent from "./AdditionsReportContent";
import HiddenPdfTemplate from "./HiddenPdfTemplate";
import AssemblyReport from "./AssemblyReport";

/**
 * RfiReportManager - Manages all PDF report rendering and preview functionality
 *
 * This component handles:
 * - Hidden PDF templates for download generation (stages 1-7)
 *
 * @param {Object} props
 * @param {Object} props.rfiDetails - RFI details object
 * @param {boolean} props.renderHiddenTemplate - Whether to render hidden templates for PDF generation
 * @param {number|null} props.currentStageForPDF - Current stage number to render (3-7)
 */
const RfiReportManager = ({
  rfiDetails,
  renderHiddenTemplate,
  currentStageForPDF,
}) => {
  // Stage configuration for reports
  const stageReports = [
    {
      stageNumber: 1,
      title: "COMPONENTS INSPECTION REPORT",
      templateId: "stage-1-report-template",
      previewId: "components-report-preview",
      content: <HiddenPdfTemplate />,
    },
    {
      stageNumber: 2,
      title: "ASSEMBLY INSPECTION REPORT",
      templateId: "stage-2-report-template",
      previewId: "assembly-report-preview",
      content: <AssemblyReport />,
    },
    {
      stageNumber: 3,
      title: "BLASTING INSPECTION REPORT",
      templateId: "stage-3-report-template",
      previewId: "blasting-report-preview",
      content: <BlastingReportContent />,
    },
    {
      stageNumber: 4,
      title: "PRIMER COAT INSPECTION REPORT",
      templateId: "stage-4-report-template",
      previewId: "primer-report-preview",
      content: <PaintingCoatReportContent coatType="primer" />,
    },
    {
      stageNumber: 5,
      title: "SECOND COAT INSPECTION REPORT",
      templateId: "stage-5-report-template",
      previewId: "secondcoat-report-preview",
      content: <PaintingCoatReportContent coatType="secondcoat" />,
    },
    {
      stageNumber: 6,
      title: "TOP COAT INSPECTION REPORT",
      templateId: "stage-6-report-template",
      previewId: "topcoat-report-preview",
      content: <PaintingCoatReportContent coatType="topcoat" />,
    },
    {
      stageNumber: 7,
      title: "ADDITIONS INSPECTION REPORT",
      templateId: "stage-7-report-template",
      previewId: "additions-report-preview",
      content: <AdditionsReportContent />,
    },
  ];

  return (
    <>
      {renderHiddenTemplate && currentStageForPDF && (
        <>
          {stageReports.map((report) => {
            if (report.stageNumber === currentStageForPDF) {
              return (
                <ReportPdfTemplate
                  key={report.templateId}
                  rfiDetails={rfiDetails}
                  reportTitle={report.title}
                  stageNumber={report.stageNumber}
                  isVisible={false}
                  templateId={report.templateId}
                >
                  {report.content}
                </ReportPdfTemplate>
              );
            }
            return null;
          })}
        </>
      )}
      {/* Test Modal - Preview All Stage Reports */}
      {/* <Dialog
        open={showTestModal}
        onClose={onCloseTestModal}
        maxWidth="lg"
        fullWidth
        PaperProps={{
          sx: {
            maxHeight: "90vh",
            height: "90vh",
          },
        }}
      >
        <DialogTitle
          sx={{
            backgroundColor: "#ff9800",
            color: "white",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1.5,
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>
            Stage Reports Preview (Test)
          </Typography>
          <IconButton
            onClick={onCloseTestModal}
            sx={{ color: "white" }}
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={{
            p: 0,
            backgroundColor: "#f5f5f5",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            overflow: "auto",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, my: 3 }}>
            {stageReports.map((report) => (
              <Box
                key={report.previewId}
                sx={{
                  width: "210mm",
                  minHeight: "297mm",
                  backgroundColor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                }}
              >
                <ReportPdfTemplate
                  rfiDetails={rfiDetails}
                  reportTitle={report.title}
                  stageNumber={report.stageNumber}
                  isVisible={true}
                  templateId={report.previewId}
                >
                  {report.content}
                </ReportPdfTemplate>
              </Box>
            ))}
          </Box>
        </DialogContent>
      </Dialog> */}
    </>
  );
};

export default RfiReportManager;
